import { render, staticRenderFns } from "./ProductUnitSearch.vue?vue&type=template&id=814da9fe&scoped=true&"
import script from "./ProductUnitSearch.vue?vue&type=script&lang=ts&"
export * from "./ProductUnitSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ProductUnitSearch.vue?vue&type=style&index=0&id=814da9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814da9fe",
  null
  
)

export default component.exports